/**
* Created For:
* Author: chenLiYan.
* Date: 2018/12/4 0004 20:49.
*/
<template>
  <transition name="page-move">
    <div class="reset-page">
      <v-title title="修改密码" :isShowBack="true" :isDefaultBack="false" @backHandle="goBack();pushUserLog('修改密码-返回')"></v-title>
      <form class="form-wrap" autocomplete="off">
        <label class="item-li flex-wrap">
          <input v-model.trim="params.oldPassword" type="text" :maxlength="20" placeholder="输入原密码"/>
        </label>
        <label class="item-li flex-wrap">
          <input v-model.trim="params.newPassword" type="text" :maxlength="20" placeholder="输入新密码"/>
        </label>
        <label class="item-li flex-wrap">
          <input v-model.trim="reNewPassword" type="text" :maxlength="20" placeholder="再次确认新密码"/>
        </label>
        <button type="button" :class="['submit-btn',isValid ? 'valid' :'']" @click="submitHandle()">完成</button>
      </form>
      <custom-loading v-if="loading"></custom-loading>
    </div>
  </transition>
</template>

<script>
import { asyncUpdatePwd } from '@/api/auth'
export default {
  name: 'UpdatePassword',
  components: {},
  props: {},
  data () {
    return {
      loading: false,
      params: {
        oldPassword: '',
        newPassword: ''
      },
      reNewPassword: ''
    }
  },
  computed: {
    // 是否数据全部输入
    isValid () {
      return !!(this.params.oldPassword && this.params.newPassword && this.reNewPassword)
    }
  },
  beforeMount () {
    // 上报操作日志
    this.pushUserLog('修改密码')
  },
  methods: {
    // 点击确认
    submitHandle () {
      let message = ''
      if (!this.params.oldPassword) {
        message = '请输入原密码'
      } else if (!this.params.newPassword) {
        message = '请输入新密码'
      } else if (!/^.{6,20}$/.test(this.params.newPassword)) {
        message = '新密码长度6-20位'
      } else if (!this.reNewPassword) {
        message = '请确认新密码'
      } else if (this.reNewPassword !== this.params.newPassword) {
        message = '密码两次不一致'
      }
      window.scrollTo(0, 0)
      if (message) {
        this.$createDialog({
          title: '提示',
          type: 'alert',
          content: message
        }).show()
      } else if (!this.loading) {
        this.loading = true
        // 提交重置
        asyncUpdatePwd(this.params).then(res => {
          this.loading = false
          if (res.code === 1) {
            this.$createDialog({
              title: '提示',
              type: 'alert',
              content: '密码修改成功',
              onConfirm: () => {
                this.$router.replace({ name: 'index' })
              }
            }).show()
          }
        }).catch(() => {
          this.loading = false
        })
      }
      // 上报操作日志
      this.pushUserLog('修改密码-完成')
    },
    // 上报操作日志封装
    pushUserLog () {
      // 上报操作日志
      // this.$store.dispatch('PushUserLog', {
      //     menu: '修改密码',
      //     page: '修改密码',
      //     operation: text
      // })
    }
  }
}
</script>

<style lang="stylus" scoped>
    @import "../../stylus/sign/login.styl"
    // 地址选择 过渡效果
    .page-move-enter, .page-move-leave-active
        transform: translate(100%, 0)
    .page-move-enter-active, .page-move-leave-active
        transition: transform .3s
    .reset-page{
        overflow hidden
    }
    .form-wrap{
        margin-top 88px
    }
</style>
